var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 15.999C123.422 15.999 16 123.417 16 255.999C16 388.579 123.422 495.999 256 495.999S496 388.579 496 255.999C496 123.417 388.578 15.999 256 15.999ZM256 479.999C132.484 479.999 32 379.512 32 255.999S132.484 31.999 256 31.999S480 132.485 480 255.999S379.516 479.999 256 479.999ZM264 252.686V95.999C264 91.577 260.406 87.999 256 87.999S248 91.577 248 95.999V259.311L346.344 357.655C347.906 359.218 349.938 359.999 352 359.999S356.094 359.218 357.656 357.655C360.781 354.53 360.781 349.468 357.656 346.343L264 252.686Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.631529c5f41e91eaf8f530f3301b2c6e.svg";
export { ForwardRef as ReactComponent };